module.exports = __webpack_public_path__ + "img/Pic_LGA_Child.e9fb1a39.png";